import { observer } from "mobx-react";
import { downloadIcon } from "../../assets";


const ImageDownloader = ({ imageData }) => {
  
  const imageUrl = imageData.presignedUrl;
  const filename = imageData.filename;

  const downloadImage = async () => {
    try {
      const response = await fetch(imageUrl, { mode: 'cors' });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;  // İndirilen dosyanın adı
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('İndirme başarısız:', error);
    }
  };

  return (
    <button className="button-round button-round-medium" onClick={downloadImage}>
      <img src={downloadIcon} alt="download" />
    </button>
  );
};

export default observer(ImageDownloader);